import { env } from './EnvironmentConfig'

export const APP_NAME = 'Booker';
export const API_BASE_URL = env.API_ENDPOINT_URL

export const APP_PREFIX_PATH = '';